export default class Delete {
  constructor() {
    this.deleteGroups = document.querySelectorAll('.delete-object');

    if (this.deleteGroups.length) {
      this.deleteGroups.forEach(deleteGroup => {
        const deleteBtn = deleteGroup.querySelector('.js-delete-object-btn');
        const errorLabel = deleteGroup.querySelector('.error');
        const confirmInput = deleteGroup.querySelector('#confirm_delete');

        deleteBtn && deleteBtn.addEventListener('click', this.initDelete.bind(this, confirmInput, errorLabel, deleteBtn));
      });
    }
  }

  initDelete(input, errorLabel, deleteBtn) {
    deleteBtn.disabled = true;

    const { deleteUrl, successUrl } = input.dataset;

    if (input && input.value === 'DELETE') {
      this.toggleErrorLabel(errorLabel, false);

      $.ajax({
        url: deleteUrl,
        type: 'post',
        dataType: 'json',
        success: () => {
          top.closeAction();
          top.document.location = successUrl;
        }
      });
    } else {
      deleteBtn.disabled = false;
      this.toggleErrorLabel(errorLabel, true);
    }
  }

  toggleErrorLabel(errorLabel, isError) {
    if ( !errorLabel ) return;

    if ( isError ) {
      errorLabel.classList.remove('d-none');
      errorLabel.classList.add('d-block');
    } else {
      errorLabel.classList.add('d-none');
      errorLabel.classList.remove('d-block');
    }
  }
}
